import { createFileRoute } from '@tanstack/react-router';
import { getAccessibleWorkspaces, useAccessContext } from '@vizit/access';
import { EntityGrid } from '@vizit/organisms';
import { guardFlatWorkspaceGrid } from '../../../router/route-utils';
import { workspaceRoute } from '../../../router/workspace-routes';
import { HierarchyGridPage } from '../../../templates';

export const Route = createFileRoute('/_authenticated/workspaces/')({
  staticData: {
    pageName: 'My Workspaces',
  },
  beforeLoad: async ({ context }) => {
    await guardFlatWorkspaceGrid(context);
  },
  component: WorkspacesRoute,
});

function WorkspacesRoute() {
  const { me, isLoading } = useAccessContext();
  const workspaces = me ? getAccessibleWorkspaces(me) : [];

  const items = workspaces.map((workspace) => ({
    id: workspace.id,
    name: workspace.name,
    href: workspaceRoute(workspace.slug),
  }));

  return (
    <HierarchyGridPage title="My workspaces" className="gap-8">
      <EntityGrid items={items} isLoading={isLoading} emptyState={<p>No workspaces available.</p>} />
    </HierarchyGridPage>
  );
}
